import { render, staticRenderFns } from "./FrenchWindowDescription.vue?vue&type=template&id=449c8353&scoped=true"
import script from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c8353",
  null
  
)

export default component.exports